import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import Disclaimer from "../../../components/model/Disclaimer";
import TabPanel from "../../../components/model/TabPanel";
import Text2ArtModel from "./Text2ArtModel";

const Text2Art = () => {
    return <ModelContainer>
        <div>
            <ModelTitle>Art Generation</ModelTitle>
            <ModelInfo model={GAEventModels.TEXT2ART}/>
            <TabPanel
                modelName={GAEventModels.TEXT2ART}
                modelDescription={<ModelDescription>Enter a text description and the AI will generate a picture matching it!</ModelDescription>}
                content={<Text2ArtModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default Text2Art;



// WEBPACK FOOTER //
// ./src/routes/Dashboard/Text2Art/index.tsx